import React from 'react';
import { FollowUpsList } from './components/FollowUpsList';

export const FollowUpsPage = () => {
  return (
    <div className="h-full flex flex-col">
      <FollowUpsList />
    </div>
  );
};
